export default "__VITE_ASSET__CoIsd86___"